class ProductStickyBar extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      header: "#shopify-section-header",
      addToCart: "[js-add-to-cart]",
      preorderMessage: "[js-preorder-message]",
      bundleContainer: "[js-bundle-container]",
      stickyAddToCart: "[js-sticky-atc]"
    };
  }

  connectedCallback() {
    this.header = document.querySelector(this._selectors.header);
    if (this.getAttribute('data-product-template') == 'bundle') {
      this.referenceButton = document.querySelector(`${this._selectors.bundleContainer}[data-active="true"] ${this._selectors.addToCart}`)
    }else{
      this.referenceButton = document.querySelector(this._selectors.addToCart);
    }

    this.stickyAddToCart = this.querySelector(this._selectors.stickyAddToCart);

    this._updateBtnState();
    this._updatePreorderMessage();
    this._toggleStickyBar();
    this._setListeners();
  }

  _setListeners = () => {
    document.addEventListener('scroll', this._toggleStickyBar);
  }

  _updatePreorderMessage(){
    this.preorderMessage = document.querySelector(`.product__information ${this._selectors.preorderMessage} div`)

    if(this.preorderMessage){

      this.preorderMessageLocations = Array.from(this.querySelectorAll(this._selectors.preorderMessage))
      this.preorderMessageLocations.forEach((wrapper) => {
        wrapper.classList.remove('hidden')
        wrapper.querySelector('div').innerHTML = this.preorderMessage.innerHTML
      })

    }
  }

  _updateBtnState = () => {
    this.stickyAddToCart.disabled = this.referenceButton.disabled;
    this.stickyAddToCart.textContent = this.referenceButton.textContent;
  }

  _toggleStickyBar = () => {
    const rect = this.referenceButton.getBoundingClientRect();
    if (rect.top >= this.header.clientHeight &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    ) {
      this.classList.add('hidden');
    } else {
      this.classList.remove('hidden');
    }
  }
}

if (!customElements.get('product-sticky-bar')) customElements.define('product-sticky-bar', ProductStickyBar)